import React from 'react';
import './SwiperPagination.scss';

type SwiperPaginationProps = {}

const SwiperPagination: React.FC<SwiperPaginationProps> = props => {
	return <div className="SwiperPagination swiper-pagination" />
}

export default SwiperPagination;